import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Star } from 'lucide-react';
import { getRatingTier } from '../helpers';
import { useMovieModal } from '../MovieModalContext';
import { FadeInImage } from './FadeInImage';
import { ReleaseDateBadge } from './ReleaseDateBadge';

dayjs.extend(relativeTime);

interface ActivityCardProps {
  movie: any;
  activity: any;
}

export function ActivityCard({ movie, activity }: ActivityCardProps) {
  const { openMovie } = useMovieModal();
  const date = dayjs(activity.rating_date ?? activity.watchlist_date);

  const externalRating = movie.average_rating
    ? Math.round(movie.average_rating)
    : null;

  const posterUrl = movie.poster_path
    ? `https://image.tmdb.org/t/p/w200${movie.poster_path}`
    : 'https://via.placeholder.com/200x300?text=No+Poster';

  return (
    <div
      onClick={() => openMovie(Number(movie.id))}
      className="activity-card"
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openMovie(Number(movie.id));
        }
      }}
      aria-label={`${movie.title} (${movie.release_year})`}
    >
      <div className="activity-card__poster">
        <FadeInImage
          src={posterUrl}
          alt={movie.title}
          loading="lazy"
          fallbackSrc="https://via.placeholder.com/200x300?text=No+Poster"
        />
        {externalRating && (
          <div
            className={`activity-card__rating-badge activity-card__rating-badge--${getRatingTier(externalRating)}`}
          >
            {Math.round(externalRating)}
          </div>
        )}
      </div>

      <div className="activity-card__content">
        <div className="activity-card__info">
          <p title={movie.title} className="activity-card__title">
            {movie.title}
          </p>
          <ReleaseDateBadge
            releaseDate={movie.release_date}
            releaseYear={movie.release_year}
            className="activity-card__year"
          />
        </div>

        <div className="activity-card__meta">
          <span className="activity-card__username">
            {activity.display_name ?? activity.username}
          </span>

          {activity.rating && (
            <div
              className={`activity-card__user-rating activity-card__user-rating--${getRatingTier(activity.rating * 20)}`}
            >
              <Star fill="currentColor" />
              {activity.rating}
            </div>
          )}
        </div>

        <span
          className="activity-card__timestamp"
          title={date.format('DD.MM.YYYY HH:mm')}
        >
          {date.fromNow()}
        </span>
      </div>
    </div>
  );
}
